module.exports = __webpack_public_path__ + "static/img/qr-code.e1f8611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code.png
// module id = li4h
// module chunks = 10